const ThreeDScene = {
  canvas: {
    backgroundColor: "#00d3ee",
  },
};

export default ThreeDScene;
